import { Controller } from "@hotwired/stimulus"

// Dynamic nested form rows (cocoon-style, no gem). `add` clones the <template>, giving the new row
// a unique index in place of the NEW_RECORD placeholder; `remove` deletes an unsaved row outright,
// or flags a persisted one for destruction (_destroy) and hides it.
export default class extends Controller {
  static targets = ["list", "template"]

  add(event) {
    event.preventDefault()
    const html = this.templateTarget.innerHTML.replace(/NEW_RECORD/g, new Date().getTime().toString())
    this.listTarget.insertAdjacentHTML("beforeend", html)
  }

  remove(event) {
    event.preventDefault()
    const row = event.target.closest("[data-nested-fields-target='row']")
    const persisted = row.querySelector("input[name*='[id]']")
    if (persisted) {
      row.querySelector("[data-nested-fields-target='destroy']").value = "1"
      row.classList.add("hidden")
    } else {
      row.remove()
    }
  }
}
